<template>
    <q-dialog v-model="showModal" persistent>
        <q-card style="width: 400px; max-width: 60vw;">
            <q-card-section class="bg-form-bar">
                <q-item class="q-pa-none">
                    <q-item-section side>
                        <q-icon name="fa fa-id-card" color="white" size="md"/>
                    </q-item-section>

                    <q-item-section>
                        <q-item-label class="text-h6">{{$t('transactions.id_document')}}</q-item-label>
                        <q-item-label  class="text-white">{{ userData.first_name }} {{userData.middle_name}} {{userData.last_name}} ( {{ userData.client_code }} )</q-item-label>
                        <q-item-label  class="text-white">{{ userData.date_of_birth }}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-card-section>

            <q-card-section>
                <q-inner-loading style="z-index: 999" :showing="loading">
                    <q-spinner-dots size="100px" color="input-color"/>
                </q-inner-loading>
                <id-document-form v-model="userObj" />
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="$t('cancel')" color="primary" v-close-popup/>
                <q-btn :label="$t('save')" color="primary" @click="save" :loading="loading" :disabled="!allFieldsFilled"/>
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

import IdDocumentForm from "./IdDocumentForm"
import User from "../../models/User"
export default {
    name: "IdDocumentDialog",
    model: {
        prop: 'open',
        event: 'change'
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        userId: {
            type: Number,
            required: true
        },
        userData: {
            type: Object,
            required: true
        }
    },
    computed: {
        showModal: {
            get: function () {
                return this.open
            },
            set: function (value) {
                this.$emit('change', value)
            }
        },
        allFieldsFilled() {
            return this.userObj.country
                && this.userObj.type
                && this.userObj.id_number
                && this.userObj.expiry_date
        }
    },
    data() {
        return {
            loading: false,
            userObj: new User({
                id: this.userId,
                country: '',
                type: 'passport',
                id_number: '',
                expiry_date: '',
            })
        }
    },
    methods: {
        fetchIdDocument() {
            this.loading = true
            this.userObj.getIdDocument(data => {
                this.loading = false
            }).catch(error => {
                this.loading = false
            })
        },
        save() {
            this.loading = true
            this.userObj.storeIdDocument(() => {
                this.loading = false
                this.showModal = false
            }).catch(error => {
                this.loading = false
            })
        }
    },
    created() {
        this.fetchIdDocument()
    },
    mounted() {},
    components: {IdDocumentForm},
}
</script>
<style>

</style>
